/// <reference path='_all.ts' />


// CHEAT SHEET: http://ivision.com/wp-content/uploads/AngularJS_v2.pdf


/**
 * The main Menu.
 *
 * @type {angular.Module}
 */
module user {
  'use strict';

  var nav = angular.module('user', ['ngAnimate', 'ngLocale', 'ngMaterial', 'ngMessages', 'partner', 'angular-cache'])
    .config(materialTheme)
    .config(DateLocaleProvider)
    .controller('ForgotPasswordCtrl', ForgotPasswordCtrl)
    .controller('ChangePasswordCtrl', ChangePasswordCtrl)
    .controller('MobileLoginCtrl', MobileLoginCtrl)
    .controller('LoginPageCtrl', LoginPageCtrl) 
    .controller('SubscribeNewsletterCtrl', SubscribeNewsletterCtrl)
    .directive('ifLoggedIn', ifLoggedIn)
    .directive('loginHeader', LoginHeaderDirective)
    .directive('loginForm', LoginFormDirective)
    .directive('registerForm', RegisterFormDirective) 
    .directive('match', matchValidator)
    .service('userService', UserService);
}